<template>
    <div>
        <b-overlay
            :show="sub_layout_loading"
            rounded="sm"
            blur="0"
            opacity="0.5"
            z-index="9999"
        >
            <div id="campaign-container">
                <div class="w-100 text-center bgray-200 pt-3 position-relative"
                     :class="admin_mode !== 'project' ? '' : 'teal8'"
                >
                    <h3 class="f-160 py-5">
                        {{
                            admin_mode !== 'project' ? campaign_data.campaign_name : `${campaign_data.client}/${campaign_data.project_code}`
                        }}
                    </h3>
                    <b-nav tabs align="center" class="">
                        <b-nav-item
                            :active="['ProjectProgress', 'CampaignProgress'].includes($route.name)"
                            class="sub-nav"
                            :to="{ name: admin_mode === 'project' ? 'ProjectProgress' : 'CampaignProgress', query: nav_submenu_query }"
                        >
                            진행현황
                        </b-nav-item>
                        <b-nav-item
                            class="sub-nav"
                            :to="{ name: 'Answers', query: nav_submenu_query }"
                            :active="$route.name === 'Answers'"
                        >
                            <!-- :active="sub_menu[1]" -->
                            기업별 답변
                        </b-nav-item>
                        <b-nav-item
                            class="sub-nav"
                            :to="{ name: 'CampaignReport', query: nav_submenu_query }"
                            :active="$route.name === 'CampaignReport'"
                        >
                            평가결과
                        </b-nav-item>
                    </b-nav>
                    <div class="d-none d-md-block a-link-gray cursor position-absolute f-140"
                         style="top: calc(50% - 25px); left:calc(10vw - 45px)"
                         @click.stop="goPrevList"
                    >
                        <span class="pr-2" style="font-size: 1.8rem;">&lang;</span> 목록으로
                    </div>
                </div>

                <div v-if="init_error" class="text-center py-5">
                    <div class="text-danger mb-3">{{ init_error }}</div>
                    <b-button variant="dark-border" size="sm" class="mr-2" @click="initData($route.path, null)">다시 시도</b-button>
                    <b-button size="sm" @click="goList">목록으로</b-button>
                </div>
                <router-view
                    v-else
                    :value_new="value_new"
                    :target_company_name="target_company_name"
                    :class="[is_printing === true ? 'px-5' : '', 'min-vh-100']"
                >
                </router-view>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'AdminSubLayout',
    components: {},
    props: {
        value_new: {
            default: false
        },
        target_company_name: {
            default: ''
        },
    },
    data() {
        return {
            sub_menu: [true, false, false, false],
            is_printing: false,
            init_error: '',
            register_menu: [true, false],
            operation_menu: [true, false],
            campaign_data: {
                project_code: null,
                campaign_id: null,
                template_code: null,
                client: null,
                company_name: null,
                campaign_name: null,
            },
        };
    },
    computed: {
        ...mapState(['admin_mode', 'is_admin', 'user_id']),
        ...mapState('admin', ['sub_layout_loading']),
        ...mapState('project_code', ['now_project', 'project_companies']),
        ...mapState('industry_campaigns', ['campaigns']),
        nav_submenu_query() {
            if (this.admin_mode === 'project') {
                return {
                    client: this.campaign_data.client,
                    pc: this.campaign_data.project_code,
                    cmp: this.campaign_data.campaign_id,
                    admin_mode: this.admin_mode
                };
            }
            if (this.admin_mode === 'camp') {
                return {
                    campaign_name: this.campaign_data.campaign_name,
                    cmp: this.campaign_data.campaign_id,
                    template_code: this.campaign_data.template_code,
                    admin_mode: this.admin_mode
                };
            }
            return null;
        }
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(newRoute, oldRoute) {
                this.initData(newRoute, oldRoute);
            },
        }
    },
    created(){
        this.fetchAuditCategory();
    },
    methods: {
        ...mapActions('project_code', ['readSingleProjectCode', 'readSingleProjectCompaniesCampaign',]),
        ...mapActions('industry_campaigns', ['readSingleCampaignIndustries']),
        ...mapActions('admin', ['setLayoutLoading',]),
        ...mapMutations('project_code', ['update_project_companies', 'update_now_project']),
        ...mapMutations('industry_campaigns', ['update_campaigns_industries_list']),
        ...mapMutations('score', ['add_all_temp_target_companies']),
        ...mapMutations(['set_admin_mode']),
        ...mapActions('evaluations', ['fetchAuditCategory']),
        pageGo (destination) {
            this.$router.push(destination);
        },
        async setCampaignData(){
            const {client, cmp, pc, cpnm, admin_mode, template_code, campaign_name} = this.$route.query;
            /**
             * @description 쿼리 파라미터 유효성 검사
             * @type {boolean}
             */

            if(admin_mode == null){
                this.$router.push({name: 'ProjectCodeList', params: {urlError: true}});
                return;
            }
            if(admin_mode === 'project' && (pc == null )) {
                this.$router.push({name: 'ProjectCodeList', params: {urlError: true}});
                return;
            }
            if(admin_mode === 'camp' && (campaign_name == null || template_code == null || cmp == null) ) {
                this.$router.push({name: 'CampaignList', params: {urlError: true}});
                return;
            }
            
            await this.set_admin_mode(admin_mode);
             
            this.campaign_data = {
                campaign_id: cmp ?? this.$route.query.campaign_id,
                project_code: pc ?? this.$route.query.project_code,
                template_code: template_code,
                client: client ?? '',
                campaign_name: campaign_name ?? '',
                company_name: cpnm ?? this.$route.query.company_name,
            };
        },
        goList(){
            this.$router.push({name: this.admin_mode === 'project' ? 'ProjectCodeList' : 'CampaignList'});
        },
        goPrevList(){
            const {admin_mode, pc, client, template_code,campaign_name, cmp,} = this.$route.query;
            if(this.$route.path.includes('/answers/')){
                if(admin_mode === 'project'){
                    this.$router.push({name: 'CampaignReport', query: {pc: pc, client: client, admin_mode: 'project', cmp}});
                }
                else if(admin_mode === 'camp'){
                    this.$router.push({name: 'CampaignReport', query: {cmp, template_code, campaign_name, admin_mode: 'camp'}} );
                }
            }
            if(this.$route.path.includes('/campaign_report')){
                if(admin_mode === 'project'){
                    this.$router.push({name: 'ProjectCodeList'});
                }
                else {
                    this.$router.push({name: 'CampaignList'});
                }
            }
        },
        async initData(newRoute, oldRoute) {
            try {
                this.init_error = '';
                this.setLayoutLoading(true);
                
                if (oldRoute == null) {
                    await this.update_now_project({});
                    await this.update_project_companies([]);
                    await this.update_campaigns_industries_list([]);
                }
                await this.setCampaignData();
                
                if (this.admin_mode === 'project') {
                    if (this.now_project.project_code == null) {
                        await this.readSingleProjectCode({
                            project_code: this.campaign_data.project_code,
                            user_id: this.user_id
                        });
                    }
                
                    if ((this.project_companies?.length ?? 0) === 0) {
                        await this.readSingleProjectCompaniesCampaign({project_code: this.now_project.project_code }); // project_code에 해당하는 기업, 캠페인 불러오기
                        this.add_all_temp_target_companies(this.project_companies);
                        
                    }
                    
                    if (this.now_project.project_code == null) throw new Error('프로젝트 정보를 찾을 수 없습니다.');

                    if(this.campaign_data.client == null || this.campaign_data.client === '') {
                        this.campaign_data.client = this.now_project.client;

                        this.$router.push({
                            name: this.$route.name,
                            query: {
                                ...this.$route.query,
                                client: this.campaign_data.client,
                            }
                        });
                    }
                    return;
                }
                
                if (this.admin_mode === 'camp') {
                    if ((this.campaigns?.length ?? 0) === 0) {
                        await this.readSingleCampaignIndustries({user_id:this.user_id, campaign_id: this.campaign_data.campaign_id});
                        if ((this.campaigns?.length ?? 0) === 0) throw new Error('캠페인 정보를 찾을 수 없습니다.');
                        
                        this.add_all_temp_target_companies(this.campaigns[0].scoring_target_companies);
                        this.$store.commit('update_campaign', this.campaigns[0]);
                    }
                    
                    return;
                }
            }
            catch (e) {
                console.error(e);
                this.init_error = `${this.admin_mode === 'project' ? '프로젝트' : '캠페인'} 정보를 불러오지 못했습니다. 주소의 프로젝트/캠페인 값이 올바른지 확인하거나 다시 시도해 주세요.`;
            }
            finally {
                this.setLayoutLoading(false);
            }
           

        }

        /**
         * @todo 버튼 접근 권한 정리 필요.
         */
        // checkAllowed (campaign_state, campaign_type, user_admin_level, target_admin_level) {
        //     if (campaign_state === '평가중' || campaign_state === '결과배포' || campaign_state === '종료') return true;
        //     if (user_admin_level >= 4) return true;
        //     if (campaign_type === 'owner') return true;
        //     if (campaign_type === 'auditor' && user_admin_level < target_admin_level) {
        //         return false;
        //     } else {
        //         return true;
        //     }
        // },
    }
};
</script>

<style>
.sub-nav > .nav-link.active {
    color: var(--gray-800)
}

.sub-nav > .nav-link,
.sub-nav > .nav-link:hover {
    border-color: rgba(0, 0, 0, 0);
}

.sub-nav > a {
    color: var(--gray-600);
}

.sub-nav > a:hover {
    color: var(--gray-800);
}

.arrow-line-up {
    border-top: 1px solid #ff00ff;
    height: 100px;
    margin-left: -140px;
    transform: rotate(45deg);
}

.arrow-line-down {
    border-top: 1px solid #ff00ff;
    height: 100px;
    margin-left: -140px;
    transform: rotate(135deg);
}

.arrow-line {
    position: relative;
    height: 100px;
}

.arrow-line::before {
    content: '';
    position: absolute;
    left: 100%;
    z-index: -1;
    width: 28px;
    height: 28px;
    border-right: 2px solid black;
    border-bottom: 2px solid black;
    transform: rotate(-45deg) translate(-14px, -7px);
}
</style>
